import Main from "./Main";
import { ThemeContextProvider, UserContextProvider } from "./global";

function App() {
  // disable pinch multitouch and refresh on pulldown
  window.addEventListener("touchmove", disablePinch, { passive: false });
  function disablePinch(event) {
    if (event.touches.length > 1) {
      //the event is multi-touch
      //you can then prevent the behavior
      event.preventDefault();
    }
  }

  return (
    <UserContextProvider>
      <ThemeContextProvider>
        <Main />
      </ThemeContextProvider>
    </UserContextProvider>
  );
}

export default App;
